// extracted by mini-css-extract-plugin
export var root = "z_tL";
export var wrapper = "z_tM";
export var image = "z_tN d_w d_y d_W";
export var imageWithHeight = "z_tP";
export var crop = "z_tQ";
export var round = "z_tR";
export var fixedHeight = "z_tS";